import { FilterButton, SearchField, types } from "@vilocnv/allsetra-core";
import { FC } from "react";
import { Box, Theme } from "@mui/material";
import { TFunction } from "i18next";
import { FormikHelpers } from "formik";
import ObjectsMapFilterForm, {
  ObjectsMapFilterFormValues
} from "components/forms/objects/ObjectsMapFilterForm";
import { FilterIcon } from "assets/icons";
import { SidePanelSearchRow } from "./Map.styled";

interface DashboardMapFilterProps {
  markers: types.MarkerType[];
  isFilterModalOpen: boolean;
  onFilterModalCloseClick: () => void;
  onFilterModalOpenClick: () => void;
  onFilterChange: (value: string) => void;
  onModalFormSubmit: (
    values: ObjectsMapFilterFormValues,
    formikHelpers: FormikHelpers<ObjectsMapFilterFormValues>
  ) => void;
  isLoadingGroups: boolean;
  group: any[];
  isLoadingObjectTypes: boolean;
  objectTypes: types.IObjectType[];
  isLoadingActiveAccountKeys: boolean;
  activeAccountKeys: types.IKey[];
  mapFilters: types.IMapFilter;
  showInactiveObjects: boolean;
  theme: Theme;
  t: TFunction;
  isSelectOpen: boolean;
  setIsSelectOpen: (value: boolean) => void;
  showSearch?: boolean;
  isLoadingSearch?: boolean;
}

const DashboardMapFilter: FC<DashboardMapFilterProps> = ({
  isFilterModalOpen,
  onFilterModalCloseClick,
  onFilterModalOpenClick,
  onModalFormSubmit,
  group,
  objectTypes,
  activeAccountKeys,
  isLoadingGroups,
  isLoadingObjectTypes,
  isLoadingActiveAccountKeys,
  mapFilters,
  showInactiveObjects,
  theme,
  t,
  showSearch = true,
  isLoadingSearch = false
}) => {
  return (
    <>
      <ObjectsMapFilterForm
        open={isFilterModalOpen}
        onClose={onFilterModalCloseClick}
        onSubmit={onModalFormSubmit}
        groups={group}
        types={objectTypes}
        keys={activeAccountKeys}
        dataLoading={
          isLoadingActiveAccountKeys || isLoadingObjectTypes || isLoadingGroups
        }
        theme={theme}
        initialValues={{
          ...mapFilters,
          showInactiveObjects
        }}
        translator={t}
        submitting={false}
      />
      <SidePanelSearchRow>
        {showSearch && (
          <Box
            sx={{
              background: "#fff",
              borderRadius: "6px",
              flex: "1 1 auto",
              minWidth: 0
            }}
          >
            <SearchField
              placeholder={"Search Objects"}
              isLoading={isLoadingSearch}
              fullWidth
            />
          </Box>
        )}
        <FilterButton
          id="filter-button"
          theme={theme}
          onClick={onFilterModalOpenClick}
          icon={<FilterIcon color={theme.palette.primary.main} />}
          sx={{
            width: "48px !important",
            minWidth: "48px !important",
            maxWidth: "48px !important",
            height: "48px",
            flex: "0 0 48px",
            padding: 0,
            "&:hover": {
              backgroundColor: "rgb(0, 150, 138) !important"
            }
          }}
        />
      </SidePanelSearchRow>
    </>
  );
};

export default DashboardMapFilter;
